import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { LoadingApp } from 'components/Loading/Loading';
import { initializeApp } from './actions';
import Body from './Body';
import 'assets/scss/app.scss';

class App extends React.Component {
  componentDidMount () {
    const { initializeAppConnect } = this.props;
    initializeAppConnect();
  }

  render () {
    const { isReady, isLoading } = this.props;
    return (
      <div className='wrapper'>
        <Body />
        <LoadingApp loading={!isReady || isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isReady: state.app.isReady,
  isLoading: state.app.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  initializeAppConnect: () => {
    dispatch(initializeApp());
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(App),
);
